import { CREATOR_CODE_COOKIE, CREATOR_CODE } from "/app/src/routes/{-$locale}/store/$namespace/$slug.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/store/$namespace/$slug.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
const RedirectSchema = z.object({
  ns: z.string(),
  id: z.string()
});
export const Route = createFileRoute("/{-$locale}/store/$namespace/$slug")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: ({
    search,
    params,
    context
  }) => {
    const {
      namespace,
      slug
    } = params;
    const creatorCodePref = context.cookies?.[CREATOR_CODE_COOKIE];
    if (creatorCodePref !== undefined) {
      const url = new URL(`https://store.epicgames.com/${namespace}/${slug}`);
      url.searchParams.set("utm_source", "egdata.app");
      if (creatorCodePref === "true") {
        url.searchParams.set("epic_creator_id", CREATOR_CODE);
        url.searchParams.set("epic_game_id", search.ns);
      }
      throw redirect({
        href: url.toString()
      });
    }
    return {
      namespace,
      slug
    };
  },
  validateSearch: RedirectSchema
});